var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'rtl-dir': _vm.direction === 'rtl' },attrs:{"id":"app","dir":_vm.direction}},[_c('div',{staticClass:"wrapper",class:'wrapper_' + _vm.$route.name},[_c('PageHeader'),_c('main',[_c('router-view')],1),_c('PageFooter'),_c('div',{staticClass:"overlay-bg"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }